export const GRID_ROW_COUNT = 2
export const GRID_COL_COUNT = 4

const createDefaultCell = () => ({
  rowspan: 1,
  colspan: 1,
  items: [],
})

export const createDefaultGridData = (row = GRID_ROW_COUNT, col = GRID_COL_COUNT) => (
  Array.from({ length: row }, () => Array.from({ length: col }, () => createDefaultCell()))
)

const toPositiveInt = (value, fallback = 1) => {
  const normalized = Number(value)
  return Number.isInteger(normalized) && normalized > 0 ? normalized : fallback
}

const hasOccupiedCell = (occupied, rowIndex, cellIndex, rowspan, colspan) => {
  for (let row = rowIndex; row < rowIndex + rowspan; row += 1) {
    for (let col = cellIndex; col < cellIndex + colspan; col += 1) {
      if (occupied[row]?.[col]) {
        return true
      }
    }
  }
  return false
}

const sanitizeCellItems = (items, usedIds) => {
  if (!Array.isArray(items)) {
    return []
  }

  for (const item of items) {
    if (!item || typeof item !== 'object' || !item.id) {
      continue
    }

    const itemId = String(item.id)
    if (usedIds.has(itemId)) {
      continue
    }

    usedIds.add(itemId)
    return [{ ...item }]
  }

  return []
}

export const normalizeMergeGridData = (sourceData, options = {}) => {
  const rowCount = toPositiveInt(options.row, GRID_ROW_COUNT)
  const colCount = toPositiveInt(options.col, GRID_COL_COUNT)
  const result = createDefaultGridData(rowCount, colCount)
  const occupied = Array.from({ length: rowCount }, () => Array(colCount).fill(false))
  const usedIds = new Set()

  if (!Array.isArray(sourceData)) {
    return result
  }

  for (let rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    const sourceRow = Array.isArray(sourceData[rowIndex]) ? sourceData[rowIndex] : []

    for (let cellIndex = 0; cellIndex < colCount; cellIndex += 1) {
      const sourceCell = sourceRow[cellIndex]
      if (!sourceCell || typeof sourceCell !== 'object') {
        continue
      }

      if (sourceCell.isMerge || occupied[rowIndex][cellIndex]) {
        continue
      }

      let rowspan = Math.min(toPositiveInt(sourceCell.rowspan, 1), rowCount - rowIndex)
      let colspan = Math.min(toPositiveInt(sourceCell.colspan, 1), colCount - cellIndex)

      if (hasOccupiedCell(occupied, rowIndex, cellIndex, rowspan, colspan)) {
        rowspan = 1
        colspan = 1
      }

      result[rowIndex][cellIndex] = {
        rowspan,
        colspan,
        items: sanitizeCellItems(sourceCell.items, usedIds),
      }

      for (let row = rowIndex; row < rowIndex + rowspan; row += 1) {
        for (let col = cellIndex; col < cellIndex + colspan; col += 1) {
          occupied[row][col] = true
          if (row !== rowIndex || col !== cellIndex) {
            result[row][col] = {
              ...createDefaultCell(),
              isMerge: true,
            }
          }
        }
      }
    }
  }

  return result
}
